import ar from './ar.json';
import en from './en.json';
import { DEFAULT_LANGUAGE } from '../common';

const langs = { ar, en };
let lang = ar;
let en_lang = en;
let isAR =
    JSON.parse(JSON.stringify(localStorage.getItem('lang') || '{}')) === 'ar';
let isEN =
    JSON.parse(JSON.stringify(localStorage.getItem('lang')) || '{}') === 'en';

const setLanguage = (lg) => {
    lang = langs[lg];
    isAR = lg === 'ar';
    isEN = lg === 'en';
    if (isAR) {
        document.getElementsByTagName('html')[0].setAttribute('lang', 'ar');
        document.getElementsByTagName('html')[0].setAttribute('dir', 'rtl');
        document.getElementById('root').style.textAlign = 'right';
        document.getElementById('root').dir = 'rtl';
    } else {
        document.getElementsByTagName('html')[0].setAttribute('lang', 'en');
        document.getElementsByTagName('html')[0].setAttribute('dir', 'ltr');
        document.getElementById('root').style.fontFamily =
            '"Open Sans", sans-serif';
        document.getElementById('root').style.textAlign = 'left';
        document.getElementById('root').dir = 'ltr';
    }
};

export { lang, en_lang, setLanguage, isAR, isEN };
